import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';
import type { Space } from '../../controllers/space-store/types';

export type ListSpacesResponse = { data: Space[]; total_count: number };

export type ListSpacesFetchParams = {
	cloudId: string;
	product: string;
	experienceId: string;
};

export const listSpacesFetchAction = async ({
	cloudId,
	product,
	experienceId,
}: ListSpacesFetchParams): Promise<ListSpacesResponse> =>
	performHttpFetch({
		path: SPACES_API_PATH,
		options: {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
		},
	});
